<section>
    <div class="rounded-lg bg-grey-white_smoke dark:bg-contrast-black lg:p-4">
        <!-- Will be implemented in the future -->
        <!--  <div class="flex items-center gap-1 rounded-lg bg-secondary px-2.5 py-4" role="note">
            <mat-icon class="!w-9" svgIcon="info"></mat-icon>
            <p class="text-base text-black">
                {{ 'SET_UP_AUTOMATIC_TOP_UP' | translate }}
                <a href="#">{{ 'SET_HERE' | translate }}</a>
            </p>
        </div> -->

        <gl-wallet-loading-page-v2-select-amount></gl-wallet-loading-page-v2-select-amount>
        <gl-wallet-loading-page-v2-select-card
            (cardFormValidity)="onCardFormValidityChange($event)"></gl-wallet-loading-page-v2-select-card>
    </div>

    <div class="mt-8 hidden lg:flex lg:items-center lg:justify-between">
        <ion-button
            class="text-base font-semibold normal-case leading-5"
            (click)="handleBackClicked()"
            color="secondary"
            fill="clear">
            <ion-icon class="mr-3.5" name="arrow-back-outline"></ion-icon>
            {{ 'PREVIOUS_BUTTON' | translate }}
        </ion-button>
        <ion-button
            class="next-button tartu-light:text-white tallinn-light:text-white w-80 dark:border-contrast-yellow"
            [disabled]="isNextDisabled"
            (click)="handleNextClicked()"
            size="large">
            <ion-label
                class="vl-app-light:text-black whitespace-normal text-base font-bold normal-case dark:text-contrast-black"
                [class.gl-light:text-white]="!isNextDisabled"
                [class.gl-light:text-black]="isNextDisabled">
                {{ 'NEXT_BUTTON' | translate }}
            </ion-label>
            <ion-icon
                class="vl-app-light:text-black dark:text-contrast-black"
                [class.gl-light:text-white]="!isNextDisabled"
                [class.gl-light:text-black]="isNextDisabled"
                name="arrow-forward-outline"
                slot="end"></ion-icon>
        </ion-button>
    </div>
</section>
